// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".paddingTop[data-v-594a22bc]{padding-top:0!important}.content-title[data-v-594a22bc]{background-color:#fff}", ""]);
// Exports
module.exports = exports;
